import RouteMap from "./routeMap.json";

class RouteValidator {
    constructor({ store = {} }) {
        this.store = store;
    }

    isAlwaysAllowed(route) {
        return RouteMap.alwaysAllowed.indexOf(route) > -1;
    }

    isValidRoute(route, from) {
        if (this.isAlwaysAllowed(route.name)) {
            return true;
        } else if (from.name !== null && RouteMap.routes[from.name].canAccess.indexOf(route.name) > -1) {
            return from.isStep ? this.store.state.hypo.currentStepComplete : true;
        }
        return false;
    }
}

export default RouteValidator;
